import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import { Row, Col, Form, Stack } from "react-bootstrap";

import { useAuth } from "hooks/useAuth";

const ProductDetailsSubheader = ({ product, loadProject }) => {
  const [productDetailsMetrics, setProductDetailsMetrics] = useState({});
  const [updatedInfo, setUpdatedInfo] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const { authToken, csrfToken, permissions } = useAuth();

  const getFipsStatus = (fips) => {
    if (fips === 0) {
      return "No Dependency Exists";
    } else if (fips === 1) {
      return "Unsatisified Dependency Exists";
    } else if (fips === 2) {
      return "Dependency Satisified";
    } else {
      return "TBD";
    }
  };

  const loadMetrics = useCallback(() => {
    if (product?.product_id) {
      axios
        .get(
          `${import.meta.env.VITE_DJANGO_ENDPOINT}project/product/product_details_metrics/?product_id=${product?.product_id}`,
          {
            withCredentials: true,
            headers: {
              Authorization: `Token ${authToken}`,
            },
          },
        )
        .then((response) => {
          setProductDetailsMetrics(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [product?.product_id]);

  useEffect(() => {
    loadMetrics();
  }, [loadMetrics]);

  const handleChange = (event) => {
    setUpdatedInfo({ ...updatedInfo, [event.target.name]: event.target.value });
  };

  const handleSave = () => {
    axios
      .put(
        `${import.meta.env.VITE_DJANGO_ENDPOINT}project/product/${product?.product_id}/`,
        updatedInfo,
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
            Authorization: `Token ${authToken}`,
          },
        },
      )
      .then(() => {
        loadProject();
        setIsEditing(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Row>
      <Col>
        <Stack className="ps-2 h-100">
          <h6>Number of Associated Technical Queries</h6>
          <p>{productDetailsMetrics?.tq_count}</p>
        </Stack>
      </Col>
      <Col>
        <Stack className="border-start border-secondary ps-2 h-100">
          <h6>Number of Associated Technical Decisions</h6>
          <p>{productDetailsMetrics?.td_count}</p>
        </Stack>
      </Col>

      <Col>
        <Stack className="border-start border-secondary ps-2 h-100">
          <h6>CAVP FIPS Status</h6>
          <Row>
            <Col xs={10}>
              {!isEditing && <p>{getFipsStatus(product?.fips)}</p>}
              {isEditing && (
                <Form.Select
                  name="fips"
                  onChange={handleChange}
                  defaultValue={product?.fips}
                >
                  <option value={-1}>TBD</option>
                  <option value={0}>No Dependency Exists</option>
                  <option value={1}>Unsatisified Dependency Exists</option>
                  <option value={1}>Dependency Satisified</option>
                </Form.Select>
              )}
            </Col>
            <Col xs={2}>
              {!isEditing && permissions.role_type === "NIAP" && (
                <div className="d-flex justify-content-end">
                  <EditIcon
                    color="action"
                    className="clickable"
                    style={{ fontSize: "2rem" }}
                    onClick={() => setIsEditing(true)}
                  />
                </div>
              )}
              {isEditing && (
                <div className="d-flex justify-content-end">
                  <SaveIcon
                    color="action"
                    className="clickable"
                    style={{ fontSize: "2rem" }}
                    onClick={() => handleSave()}
                  />
                </div>
              )}
            </Col>
          </Row>
        </Stack>
      </Col>
    </Row>
  );
};

export default ProductDetailsSubheader;
